import { useState } from 'react';
import MemberController from "../controllers/MemberController";
import PacmanLoader from "react-spinners/PacmanLoader";
import BulkUploadErrorModel from '../models/membership/BulkUploadErrorModel';

export default function BulkUpload() {
    const [file, setFile] = useState<File | undefined>();
    const [submitLoading, setSubmitLoading] = useState(false);
    const [errors, setErrors] = useState("");
    const [errorModel, setErrorModel] = useState<BulkUploadErrorModel[] | null>(null);
    const memberController = new MemberController();

    const saveFile = (e: any) => {
        setFile(e.target.files[0]);
    }

    const uploadFile = async () => {
        setSubmitLoading(true);
        setErrors("");
        try
        {
        if (file) {
            var result = await memberController.BulkUpload(file);
            if(!result){
                window.location.href = ("/memberList");
            }            
            else{
                setErrorModel(result);
            }
        }}
        catch(e){
            setErrors(e.message);
            
        }
        
        finally{
            setSubmitLoading(false);
        }
    }

    return (
        <div className="col-12 mx-auto">
            <h1 className="text-center">Bulk Upload</h1>
            <br />
            <div className="col-6 mx-auto">
                <label className="form-label">Upload Ticket Tailor CSV</label>
                <input type="file" className="form-control" onChange={saveFile} />
                <br />
                {submitLoading
                    ? <div className="col-6 mx-auto text-center"><PacmanLoader color="#947a27" /></div>
                    : <input className="btn btn-lg btn-light" type="button" value="Upload" onClick={uploadFile} />
                }
                                </div>

                {errors && <div className="text-danger">{errors}</div>}
                {errorModel && errorModel.map((model, index) => {
                    return <div key={index}>
                        {model.ErrorMessage}<br />
                        <table className="table-dark table-bordered">
                            <tbody>
                                <tr>
                                <td>{model.Model.Name}</td>
                                <td>{model.Model.Email}</td>
                                <td>{model.Model.MobileNumber}</td>
                                <td>{model.Model.Address1}</td>
                                <td>{model.Model.Address2}</td>
                                <td>{model.Model.Address3}</td>
                                <td>{model.Model.Postcode}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                })}
        </div>
    )
}